// centerPointServices.js

import { SYSTEM_ERROR } from "../config/CONSTANTS";
import {
  GET_ALL_JOB_NAMES,
  GET_ALL_LOCATIONS,
  GET_CENTERPOINT_EMPLOYEE_DETAILS,
  GET_PARENT_CLIENT_CENTERPOINT,
  GET_CLIENT_CENTERPOINT,
  GET_PROGRAM_CENTERPOINT,
  GET_PROJECT_CENTERPOINT,
  GET_ALL_SUBSYTEMS,
  GET_LOGONIDS_BY_SUBSYSTEMS,
  SEARCH_CENTERPOINT_EMPLOYEES,
  GET_SYSTEM_DETAILS,
  DELETE_SYSTEM_DETAILS,
  GET_ALL_SYSTEMS_TYPE,
  GET_ALL_SYSTEMS_BY_SYSTEM_TYPE_ID,
  GET_ALL_SUBSYTEMS_BY_SYSTEM_TYPE_ID,
  ADD_SYSTEM,
  EDIT_SYSTEM,
  VALIDATE_BULK_UPLOAD_EXCEL_DATA,
  INSERT_UPLOADED_FILE,
  GET_ALL_SYSTEMS,
  GET_ALL_SUBSYTEMS_BY_SYSTEM_ID,
  GET_SYSTEM_TRANSACTION_LOGS,
  GET_EMPLOYEE_NAME_FROM_AUDIT_LOGS,
  GET_ALL_HR_SYSTEMS,
  GET_SYSTEM_DETAILS_BY_EMPLOYEE_ID,
  GET_ALL_CENTER_LOCATIONS,
  GET_ALL_EMPLOYMENT_TYPES,
  GET_SUPERVISOR_DETAILS,
  GET_ALL_EMPLOYMENT_STATUS,
  GET_ALL_DEPARTMENTS,
  GET_ALL_CLIENTS,
  GET_ALL_PROGRAMS_BY_CLIENTID,
  GET_ALL_PROJECTS_BY_CLIENT_AND_PROGRAM,
  INSERT_NON_TTEC_EMPLOYEE,
  VALIDATE_EMPLOYEE_ID,
  FETCH_NON_HRMS_EMPLOYEE_DETAILS,
  UPDATE_NON_TTEC_EMPLOYEE_DETAIL,
  REPORT_A_PROBLEM,
  FEATURE_REQUEST,
  GET_ORACLE_ID_BY_EMAIL_ID,
  SAVE_EMPLOYEEDATE_OVERRIDES,
} from "./CONSTANTS";

import axiosInstance from "./axiosInstance";

const BASE_URL = process.env.REACT_APP_BASE_URL_CONFIG;

export const getAllJobNames = () => {
  return new Promise((resolve, reject) => {
    try {
      const response = axiosInstance.get(BASE_URL + GET_ALL_JOB_NAMES());
      resolve(response);
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const getAllLocations = () => {
  return new Promise((resolve, reject) => {
    try {
      const response = axiosInstance.get(BASE_URL + GET_ALL_LOCATIONS());
      resolve(response);
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const getEmployeeDetails = (searchType, searchValue) => {
  return new Promise((resolve, reject) => {
    try {
      const response = axiosInstance.get(
        BASE_URL + GET_CENTERPOINT_EMPLOYEE_DETAILS(),
        {
          params: { searchType, searchValue },
        },
      );
      resolve(response);
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const getParentClientDetails = () => {
  return new Promise((resolve, reject) => {
    try {
      const response = axiosInstance.get(
        BASE_URL + GET_PARENT_CLIENT_CENTERPOINT(),
      );
      resolve(response);
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const getClientDetails = (parentClientId) => {
  return new Promise((resolve, reject) => {
    try {
      const response = axiosInstance.get(BASE_URL + GET_CLIENT_CENTERPOINT(), {
        params: { parentClientId },
      });
      resolve(response);
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const getProgramDetails = (parentClientId, clientId) => {
  return new Promise((resolve, reject) => {
    try {
      const response = axiosInstance.get(BASE_URL + GET_PROGRAM_CENTERPOINT(), {
        params: { parentClientId, clientId },
      });
      resolve(response);
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const getProjectDetails = (parentClientId, clientId, programId) => {
  return new Promise((resolve, reject) => {
    try {
      const response = axiosInstance.get(BASE_URL + GET_PROJECT_CENTERPOINT(), {
        params: { parentClientId, clientId, programId },
      });
      resolve(response);
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const getAllSubSystems = () => {
  return new Promise((resolve, reject) => {
    try {
      const response = axiosInstance.get(BASE_URL + GET_ALL_SUBSYTEMS());
      resolve(response);
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const getLogonIds = (subSystemId) => {
  return new Promise((resolve, reject) => {
    try {
      const response = axiosInstance.get(
        BASE_URL + GET_LOGONIDS_BY_SUBSYSTEMS(),
        {
          params: { subSystemId },
        },
      );
      resolve(response);
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const searchEmployees = (payload) => {
  return new Promise((resolve, reject) => {
    try {
      const response = axiosInstance.post(
        BASE_URL + SEARCH_CENTERPOINT_EMPLOYEES(),
        payload,
      );
      resolve(response);
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const getSystemDetails = (oracleId) => {
  return new Promise((resolve, reject) => {
    try {
      const response = axiosInstance.get(BASE_URL + GET_SYSTEM_DETAILS(), {
        params: { oracleId },
      });
      resolve(response);
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const deleteSystemDetails = (payload) => {
  return axiosInstance
    .delete(BASE_URL + DELETE_SYSTEM_DETAILS(), { data: payload })
    .catch(() => {
      throw SYSTEM_ERROR;
    });
};

export const getAllSystemTypes = () => {
  return new Promise((resolve, reject) => {
    try {
      const response = axiosInstance.get(BASE_URL + GET_ALL_SYSTEMS_TYPE());
      resolve(response);
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const getAllSystemsBySystemTypeID = (systemTypeId) => {
  return new Promise((resolve, reject) => {
    try {
      const response = axiosInstance.get(
        BASE_URL + GET_ALL_SYSTEMS_BY_SYSTEM_TYPE_ID(),
        {
          params: { systemTypeId },
        },
      );
      resolve(response);
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const getAllSubSystemsBySystemTypeID = (systemTypeId, systemId) => {
  return new Promise((resolve, reject) => {
    try {
      const response = axiosInstance.get(
        BASE_URL + GET_ALL_SUBSYTEMS_BY_SYSTEM_TYPE_ID(),
        {
          params: { systemTypeId, systemId },
        },
      );
      resolve(response);
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const addSystem = (payload) => {
  return new Promise((resolve, reject) => {
    try {
      const response = axiosInstance.post(BASE_URL + ADD_SYSTEM(), payload);
      resolve(response);
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const editSystem = (payload) => {
  return new Promise((resolve, reject) => {
    try {
      const response = axiosInstance.post(BASE_URL + EDIT_SYSTEM(), payload);
      resolve(response);
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const validateExcelData = (payload, subSystemId) => {
  return new Promise((resolve, reject) => {
    try {
      const response = axiosInstance.post(
        BASE_URL + VALIDATE_BULK_UPLOAD_EXCEL_DATA(),
        payload,
        { params: { subSystemId } },
      );
      resolve(response);
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const insertUploadedFile = (payload) => {
  return new Promise((resolve, reject) => {
    try {
      const response = axiosInstance.post(
        BASE_URL + INSERT_UPLOADED_FILE(),
        payload,
      );
      resolve(response);
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const getAllSystems = () => {
  return new Promise((resolve, reject) => {
    try {
      const response = axiosInstance.get(BASE_URL + GET_ALL_SYSTEMS());
      resolve(response);
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const getAllSubSystemsBySystemID = (systemId) => {
  return new Promise((resolve, reject) => {
    try {
      const response = axiosInstance.get(
        BASE_URL + GET_ALL_SUBSYTEMS_BY_SYSTEM_ID(),
        {
          params: { systemId },
        },
      );
      resolve(response);
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const getEmployeeSystemTransactionLogs = (payload) => {
  return new Promise((resolve, reject) => {
    try {
      const response = axiosInstance.post(
        BASE_URL + GET_SYSTEM_TRANSACTION_LOGS(),
        payload,
      );
      resolve(response);
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const getEmployeeNameFromAuditLogs = (employeeName) => {
  return new Promise((resolve, reject) => {
    try {
      const response = axiosInstance.get(
        BASE_URL + GET_EMPLOYEE_NAME_FROM_AUDIT_LOGS(),
        {
          params: { employeeName },
        },
      );
      resolve(response);
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const getAllHRSystems = () => {
  return new Promise((resolve, reject) => {
    try {
      const response = axiosInstance.get(BASE_URL + GET_ALL_HR_SYSTEMS());
      resolve(response);
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const getAllCenterLocations = () => {
  return new Promise((resolve, reject) => {
    try {
      const response = axiosInstance.get(BASE_URL + GET_ALL_CENTER_LOCATIONS());
      resolve(response);
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const getAllEmploymentTypes = () => {
  return new Promise((resolve, reject) => {
    try {
      const response = axiosInstance.get(BASE_URL + GET_ALL_EMPLOYMENT_TYPES());
      resolve(response);
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const getAllEmploymentStatus = () => {
  return new Promise((resolve, reject) => {
    try {
      const response = axiosInstance.get(
        BASE_URL + GET_ALL_EMPLOYMENT_STATUS(),
      );
      resolve(response);
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const getSupervisorDetails = (value) => {
  return new Promise((resolve, reject) => {
    try {
      const response = axiosInstance.get(BASE_URL + GET_SUPERVISOR_DETAILS(), {
        params: { firstnameOrLastnameOrOracleid: value },
      });
      resolve(response);
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const getAllClients = () => {
  return new Promise((resolve, reject) => {
    try {
      const response = axiosInstance.get(BASE_URL + GET_ALL_CLIENTS());
      resolve(response);
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const getProgramsByClientId = (clientId) => {
  return new Promise((resolve, reject) => {
    try {
      const response = axiosInstance.get(
        BASE_URL + GET_ALL_PROGRAMS_BY_CLIENTID(),
        {
          params: { clientId },
        },
      );
      resolve(response);
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const getAllProjectsByClientIdAndProgramId = (clientId, programId) => {
  return new Promise((resolve, reject) => {
    try {
      const response = axiosInstance.get(
        BASE_URL + GET_ALL_PROJECTS_BY_CLIENT_AND_PROGRAM(),
        { params: { clientId, programId } },
      );
      resolve(response);
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const getAllDepartments = () => {
  return new Promise((resolve, reject) => {
    try {
      const response = axiosInstance.get(BASE_URL + GET_ALL_DEPARTMENTS());
      resolve(response);
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const insertNonTTECEmployee = (payload) => {
  return new Promise((resolve, reject) => {
    try {
      const response = axiosInstance.post(
        BASE_URL + INSERT_NON_TTEC_EMPLOYEE(),
        payload,
      );
      resolve(response);
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const updateNonTTECEmployee = (payload) => {
  return new Promise((resolve, reject) => {
    try {
      const response = axiosInstance.post(
        BASE_URL + UPDATE_NON_TTEC_EMPLOYEE_DETAIL(),
        payload,
      );
      resolve(response);
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const getSystemDetailsByEmployeeId = (extEmpId) => {
  return new Promise((resolve, reject) => {
    try {
      const response = axiosInstance.get(
        BASE_URL + GET_SYSTEM_DETAILS_BY_EMPLOYEE_ID(),
        {
          params: { extEmpId },
        },
      );
      resolve(response);
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const validateEmployeeId = (hrEmployeeId) => {
  return new Promise((resolve, reject) => {
    try {
      const response = axiosInstance.get(BASE_URL + VALIDATE_EMPLOYEE_ID(), {
        params: { hrEmployeeId },
      });
      resolve(response);
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const getNonHRMSEmployeeDetails = (extEmpId) => {
  return new Promise((resolve, reject) => {
    try {
      const response = axiosInstance.get(
        BASE_URL + FETCH_NON_HRMS_EMPLOYEE_DETAILS(),
        {
          params: { extEmpId },
        },
      );
      resolve(response);
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

// localStorage.getItem("EmailId") is a display/identity value — intentionally kept.
export const getOracleId = () => {
  return new Promise((resolve, reject) => {
    try {
      const response = axiosInstance.get(
        BASE_URL + GET_ORACLE_ID_BY_EMAIL_ID(),
        {
          params: { emailId: localStorage.getItem("EmailId") },
        },
      );
      resolve(response);
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

// localStorage.getItem("OracleId") is a display/identity value — intentionally kept.
export const reportAproblem = (payload) => {
  return new Promise((resolve, reject) => {
    try {
      const response = axiosInstance.post(
        BASE_URL + REPORT_A_PROBLEM(),
        payload,
        {
          params: { oracleId: localStorage.getItem("OracleId") },
        },
      );
      resolve(response);
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

// localStorage.getItem("OracleId") and ("User") are display/identity values — intentionally kept.
export const featureRequest = (payload) => {
  return new Promise((resolve, reject) => {
    try {
      const response = axiosInstance.post(
        BASE_URL + FEATURE_REQUEST(),
        payload,
        {
          params: {
            oracleId: localStorage.getItem("OracleId"),
            loggedOnUserName: localStorage.getItem("User"),
          },
        },
      );
      resolve(response);
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};

export const saveEmployeeDateOverrides = (payload) => {
  return new Promise((resolve, reject) => {
    try {
      const response = axiosInstance.post(
        BASE_URL + SAVE_EMPLOYEEDATE_OVERRIDES(),
        payload,
      );
      resolve(response);
    } catch (error) {
      reject(SYSTEM_ERROR);
    }
  });
};
